var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-325 md:max-h-72 md:max-h-full mx-4 md:mx-10 xl:mx-auto mb-10 md:mb-32 border border-lumiere-lightGray h-30vh sm:h-40vh md:h-80vh margin"},[_c('editor-image',{staticClass:"h-full w-full object-cover vid",attrs:{"name":"video"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }